import { type ReactNode } from 'react';

import { useAuth } from '@/lib/auth/AuthContext';
import type { ConsoleRole } from '@/lib/auth/types';

import { ForbiddenPage } from './ForbiddenPage';

interface RequireRoleProps {
    roles: readonly ConsoleRole[];
    children: ReactNode;
}

export function RequireRole({ roles, children }: RequireRoleProps) {
    const { user } = useAuth();
    if (!user) return null;
    if (!roles.includes(user.role)) {
        return <ForbiddenPage allowed={roles} actual={user.role} />;
    }
    return <>{children}</>;
}
